import { Button, Grid, Theme } from '@material-ui/core';
import FilterListIcon from '@material-ui/icons/FilterList';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import Filter from './Filter';
import Search from './Search';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap'
  },
  search: {
    flexGrow: 1,
    maxWidth: 480,
    flexBasis: 480
  },
  filterButton: {
    marginLeft: 'auto'
  },
  filterIcon: {
    marginRight: theme.spacing(1)
  }
}));

const SearchBar = (props: { className?: string, filterContent?: any, onFilter?: (values: any) => void, onSearch?: (value: string) => any }) => {
  const {onFilter, onSearch, className, filterContent, ...rest} = props;

  const classes = useStyles();

  const [openFilter, setOpenFilter] = useState(false);

  const handleFilterOpen = () => {
    setOpenFilter(true);
  };

  const handleFilterClose = () => {
    setOpenFilter(false);
  };

  //Hacky fix to catch form submit to close the filter drawer.
  const handleFormSubmit = (event: any) => {
    const target = event.target as HTMLButtonElement;
    if(target && target.parentElement && (target.parentElement.id === 'submit' || target.parentElement.id === 'clear')) {
      handleFilterClose();
    }
  };

  return (
    <Grid
      {...rest}
      className={clsx(classes.root, className)}
      container
      spacing={3}
      onClick={handleFormSubmit}
    >
      <Grid item>
        {onSearch && (
          <Search className={classes.search} onSearch={onSearch} />
        )}
      </Grid>
      {filterContent && (
      <Grid item>
        <Button
          className={classes.filterButton}
          color="primary"
          onClick={handleFilterOpen}
          size="small"
          variant="outlined"
        >
          <FilterListIcon className={classes.filterIcon}/> Show filters
        </Button>
      </Grid>
      )}
      {filterContent && (<Filter
        content={filterContent}
        onClose={handleFilterClose}
        onFilter={onFilter}
        open={openFilter}
      />)}
    </Grid>
  );
};

export default SearchBar;
